import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { EUROPE } from 'enums/regions';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import get from 'lodash/get';
import { getNeedCaseFileDownloadInfo } from 'utils/projectFiles';
import { putEndUserCaseStudyFile } from 'utils/warrantyFileLinks';
import { toast } from 'react-toastify';
import axios from 'axios';
import { DropzoneDialog } from 'material-ui-dropzone';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;
const toastConfig = { autoClose: 3000 };

const Project = ({ values, setValues, getProject }) => {
  const intl = useIntl();
  const { code } = useParams();
  const [uploadOpen, setUploadOpen] = useState(false);

  const needCaseRaw = get(values, 'data.needCase', false);
  const needCase = needCaseRaw === true;
  const needCaseFile = getNeedCaseFileDownloadInfo(values.data);

  const isEuropeCountry = EUROPE.includes(values.data.country);

  const handleDownloadFile = async () => {
    if (!needCaseFile?.uuid) {
      console.error('Need case file uuid is not available.');
      return;
    }

    try {
      const endUserFileUrl = `${API_URL}/bulk/download-stream/${encodeURIComponent(
        needCaseFile.uuid,
      )}`;
      const response = await axios.get(endUserFileUrl, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: 'blob',
      });

      const fallbackName =
        needCaseFile.name ||
        (needCaseFile.key &&
          needCaseFile.key.split('/').filter(Boolean).pop()) ||
        'certificado';
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = fallbackName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      toast.error(
        <FormattedMessage id="Hubo un error al descargar el archivo" />,
        toastConfig,
      );
    }
  };

  const handleUploadSave = async (files) => {
    if (!files.length || !code) return;
    const file = files[0];
    const newFileName = `end_user-${file.name}`;
    const blob = new Blob([file], { type: file.type });
    const renamed = new File([blob], newFileName, { type: file.type });
    const formData = new FormData();
    formData.append('file', renamed);
    try {
      const uploadRes = await axios.post(`${API_URL}/bulk/upload`, formData, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
        },
      });
      const uuid = uploadRes.data?.uuid;
      if (!uuid) {
        throw new Error('Upload response missing uuid');
      }
      const putRes = await putEndUserCaseStudyFile(code, [uuid]);
      if (typeof setValues === 'function' && putRes.data) {
        setValues(putRes.data);
      }
      if (typeof getProject === 'function') {
        getProject({ code });
      }
      setUploadOpen(false);
      toast.success(
        <FormattedMessage id="El archivo se envio correctamente" />,
        toastConfig,
      );
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      setUploadOpen(false);
      toast.error(
        <FormattedMessage id="Hubo un error al enviar el archivo" />,
        toastConfig,
      );
    }
  };

  return (
    <div className="row">
      <div className="col-12 ViewOrEdit">
        <div>
          <strong>
            <FormattedMessage id="Nombre del proyecto:" />
          </strong>
          <span>{get(values, 'data.name', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Tipo de proyecto:" />
          </strong>
          {/* <span>
            <FormattedMessage id={get(values, 'data.type', '-')} />
          </span> */}
          <span>{get(values, 'data.type', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Principal necesidad:" />
          </strong>
          {/* <span>
            <FormattedMessage id={get(values, 'data.need', '-')} />
          </span> */}
          <span>{get(values, 'data.need', '-')}</span>
        </div>
        {/* <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Calle:" />
          </strong>
          <span>{get(values, 'data.address', '-')}</span>
        </div> */}
        {/* <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Número:" />
          </strong>
          <span>{get(values, 'data.number', '-')}</span>
        </div> */}
        {/* <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Piso:" />
          </strong>
          <span>{get(values, 'data.floor', '-')}</span>
        </div> */}
        {/* <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Departamento:" />
          </strong>
          <span>{get(values, 'data.department', '-')}</span>
        </div> */}
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Código postal:" />
          </strong>
          <span>{get(values, 'data.postalCode', '-')}</span>
        </div>
        <div className="kt-space-20" />
        <div>
          <strong>
            <FormattedMessage id="Provincia:" />
          </strong>
          <span>{get(values, 'data.state', '-')}</span>
        </div>
        <div className="kt-space-20" />
        {isEuropeCountry && (
          <div>
            <strong>
              <FormattedMessage id="Case of Study:" />
            </strong>
            <span>
              {needCase ? (
                <FormattedMessage id="SI" />
              ) : (
                <FormattedMessage id="NO" />
              )}
            </span>
          </div>
        )}
        <div className="kt-space-20" />

        {isEuropeCountry && needCase && (
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 12,
              }}
            >
              {needCaseFile?.uuid ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GetAppIcon />}
                  onClick={handleDownloadFile}
                >
                  <FormattedMessage id="Descargar certificado end user" />
                </Button>
              ) : (
                <>
                  <span className="text-muted">
                    <FormattedMessage id="No hay certificado end user" />
                  </span>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<CloudUploadIcon />}
                    onClick={() => setUploadOpen(true)}
                  >
                    <FormattedMessage id="Subir certificado end user" />
                  </Button>
                  <DropzoneDialog
                    showAlerts={false}
                    acceptedFiles={['application/pdf', '.csv']}
                    cancelButtonText={intl.formatMessage({ id: 'Cancel' })}
                    submitButtonText={intl.formatMessage({ id: 'Send' })}
                    dialogTitle={intl.formatMessage({ id: 'Upload file' })}
                    dropzoneText={intl.formatMessage({
                      id: 'Drag and drop a file here or click',
                    })}
                    maxFileSize={5000000}
                    open={uploadOpen}
                    onClose={() => setUploadOpen(false)}
                    onSave={handleUploadSave}
                    showPreviews={false}
                    showPreviewsInDropzone
                    showFileNames
                    filesLimit={1}
                  />
                </>
              )}
            </div>
          </div>
        )}
        {/* <div>
          <strong>
            <FormattedMessage id="Ciudad:" />
          </strong>
          <span>{get(values, 'data.city', '-')}</span>
        </div> */}
      </div>
    </div>
  );
};

export default Project;
